import type {AxiosError} from 'axios';
import {useMutation, useQueryClient, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {
	createPaymentWay,
	type CreatePaymentWayErrorResponse,
	type CreatePaymentWayRequest,
	type CreatePaymentWayResponse,
} from '../../http/paymentWays/createPaymentWay';

export function useCreatePaymentWay(
	options?: UseMutationOptions<
		CreatePaymentWayResponse,
		AxiosError<CreatePaymentWayErrorResponse>,
		CreatePaymentWayRequest
	>,
): UseMutationResult<CreatePaymentWayResponse, AxiosError<CreatePaymentWayErrorResponse>, CreatePaymentWayRequest> {
	const queryClient = useQueryClient();

	return useMutation<
		CreatePaymentWayResponse,
		AxiosError<CreatePaymentWayErrorResponse>,
		CreatePaymentWayRequest
	>((request) => createPaymentWay(request).then(({data}) => data), {
		...options,
		onSuccess: (data, variables, context) => {
			queryClient.invalidateQueries({queryKey: ['paymentWays']});
			options?.onSuccess?.(data, variables, context);
		},
	});
}
